import { useNavigate } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'

export function DashboardTaxStatusChart({ setShowNavBar }) {
  const navigate = useNavigate()

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit flex flex-col bg-[#bceda6] font-robo'>
      <div className='w-full max-sm:scale-90 flex flex-col items-center'>
        <p className='font-bold text-3xl text-center mt-4'>Let’s speed up the process!</p>
        <div className='flex flex-col items-center gap-4 mt-10'>
          <p>Get your Calculation faster by submitting a new Tax Authorization Form through the updated link. We have updated our system to safely and securely expedite the filing process for your SETC Refund.</p>
          <p>Once you have signed the Tax Authorization Form, your file will be processed within 5-7 business days and your refund will be calculated immediately.</p>
          <button onClick={() => { setShowNavBar(false); navigate(`/chartConnect/${customerData.customerLeadData.leadContact.contactId}`) }} className='bg-blue-500 hover:bg-blue-600 transition duration-200 w-52 h-12 rounded-lg text-white'>
            Connect IRS Documents
          </button>
        </div>
      </div>
    </div>
  )
}